import { render, staticRenderFns } from "./SporCasinoCozumleri.vue?vue&type=template&id=17b304c8&scoped=true"
import script from "./SporCasinoCozumleri.vue?vue&type=script&lang=js"
export * from "./SporCasinoCozumleri.vue?vue&type=script&lang=js"
import style0 from "./SporCasinoCozumleri.vue?vue&type=style&index=0&id=17b304c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b304c8",
  null
  
)

export default component.exports